import { history } from '@codemirror/commands';

export const HISTORY_EXTENSIONS = [history()];
